module.exports = __webpack_public_path__ + "static/media/re-submit.ca7a4d87.svg";